import { FaBell, FaBars } from "react-icons/fa";
import { images } from "../assets/images";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "../redux/features/loaderSlice";

const Header = () => {
   const { isSidebarOpen } = useSelector((state) => state.loader);
   const dispatch = useDispatch()

    const toggleSidebar = ()=>{
      dispatch(setSidebarOpen(!isSidebarOpen))
    }

  return (
    <header
      className="bg-white shadow flex items-center justify-between z-10 flex-shrink-0 px-4"
      style={{ padding: "14px" }}
    >
      {/* Left Section: Toggle Button and Brand Logo */}
      <div className="flex items-center space-x-4">
        <button
          onClick={toggleSidebar}
          className="text-gray-600 hover:text-gray-800 focus:outline-none"
        >
          {isSidebarOpen ? (
            <FaBars className="w-6 h-6" /> // Close icon when sidebar is open
          ) : (
            <FaBars className="w-6 h-6" /> // Menu icon when sidebar is closed
          )}
        </button>
      </div>

      {/* Right Section: Notification Icon */}
      <div className="flex items-center space-x-4">
        <button className="text-gray-600 hover:text-gray-800 relative"> 
          <FaBell
            className="w-7 h-8"
            style={{ color: "var(--primary-color)" }}
          />
          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full px-1">
            8 {/* Notification Count */}
          </span>
        </button>
       
        {/* <img src={images.brandLogo} alt="Brand Logo" className="h-8" /> */}
      </div>  
    </header>
  );
};

export default Header; // Ensure default export